import clsx from 'clsx';
import { Path } from 'path-parser';
import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { AcPopover } from '../display/AcPopover';
import style from './AcDropdownItem.module.scss';
const ConditionalWrap = ({ condition, wrap, children, }) => (condition ? wrap(children) : React.createElement(React.Fragment, null, children));
export const AcDropdownItem = ({ eventKey, data, functionContext, action, size, onMouseDown, onClickBeforeAction, }) => {
    const history = useHistory();
    const onClickItem = (e) => {
        e.preventDefault();
        e.stopPropagation();
        // if (!data) {
        // console.error('DATA NOT FOUND in AcDropdownItem');
        // return;
        // }
        onClickBeforeAction?.();
        if (action.onClick) {
            action.onClick(data || {}, functionContext || {});
        }
        else if (action.path) {
            const pathParser = new Path(action.path);
            const path = pathParser.build(data);
            history.push(path);
        }
    };
    let disabled;
    if (typeof action.disabled === 'function') {
        disabled = action.disabled(data || {}, functionContext || {});
    }
    else {
        disabled = action.disabled;
    }
    let item;
    if (typeof action.title === 'function') {
        item = action.title(data || {}, functionContext || {});
    }
    else {
        let icon;
        if (typeof action.icon === 'function') {
            icon = (React.createElement("i", { className: `${action.icon(data || {}, functionContext || {})} ${size === 'xl' || size === 'lg' ? 'fs-maximum' : 'fs-medium'} fa-fw mr-2` }));
        }
        else if (typeof action?.icon === 'string') {
            icon = (React.createElement("i", { className: `${action.icon} ${size === 'xl' || size === 'lg' ? 'fs-maximum' : 'fs-medium'} fa-fw mr-2` }));
        }
        else {
            icon = action?.icon;
        }
        item = (React.createElement(React.Fragment, null,
            icon,
            React.createElement("span", { className: size === 'xl' || size === 'lg'
                    ? 'font-weight-bold fs-default text-secondary'
                    : 'font-weight-light fs-minimum' }, action.title ? action.title : action.name),
            action?.trailing != null && React.createElement("span", { className: "ml-auto" }, action.trailing)));
    }
    let showHover;
    if (typeof action.showHover === 'function') {
        showHover = action.showHover(data || {}, functionContext || {});
    }
    else {
        showHover = action.showHover;
    }
    let hoverText;
    if (typeof action.hoverOptions?.text === 'function') {
        hoverText = action.hoverOptions.text(data || {}, functionContext || {});
    }
    else {
        hoverText = action.hoverOptions?.text;
    }
    return (React.createElement(ConditionalWrap, { condition: showHover, wrap: (children) => (React.createElement(AcPopover, { placement: action.hoverOptions?.placement, text: hoverText }, children)) },
        React.createElement(Dropdown.Item, { eventKey: eventKey, onMouseDown: onMouseDown, onClick: onClickItem, disabled: disabled, className: clsx('d-flex align-items-center', action.actionClassName, { [style.dropdownItemSm]: size === 'sm' }, { [style.dropdownItemLg]: size === 'lg' }, { [style.dropdownItemXl]: size === 'xl' }), style: {
                opacity: disabled ? 0.6 : undefined,
                minWidth: size === 'xl' ? '270px' : undefined,
            } }, item)));
};
AcDropdownItem.displayName = 'AcDropdownItem';
